<template>   
<div class="login-tab">     
<el-button autoId="btn_back" class="submit" type="text" @click="back"><img src="@/assets/images/temp/back.svg" alt="返回" />返回登录 
</el-button>     
<div v-if="!isFinish">       <h2>忘记密码</h2>       <Password :login-type="'forget'" @success="success" />     
</div>     
<div v-else class="success-setting">       <img src="@/assets/images/temp/success.svg" alt="success" />       <p>设置完成</p>       
<el-button autoId="btn_back" type="primary" @click="back">立即登录 
</el-button>     
</div>   
</div> </template>

<script>
import Password from '../../my/components/password.vue'
export default {
  components: { Password },
  data() {
    return {
      isFinish: false
    }
  },
  methods: {
    success() {
      this.isFinish = true
    },
    back() {
      this.$emit('switch', 'login')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-tab {
  width: 320px !important;
}
h2 {
  font-size: 24px;
  color: #333333;
  font-weight: 600;
}
.submit {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 16px;
  color: #333333;
  font-weight: 400;
  &:hover {
    color: black;
  }
  img {
    margin-right: 5px;
    vertical-align: top;
  }
}
.success-setting {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  p {
    font-size: 20px;
    font-weight: 500;
    margin: 20px 0;
    color: #000000;
  }
  .el-button {
    width: 287px;
    height: 40px;
    background-color: var(--color);
  }
}
</style>
